import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthentificationNotAvailable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 417,
	height: 285,
	viewBox: "0 0 417 285",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 154.337C-5.57363e-05 179.434 21.0303 239.37 66.5215 265.733C112.971 292.651 151.915 270.128 206.692 271.016C248.065 271.687 273.561 283.593 312.651 271.016C367.961 253.221 427.97 222.712 415.284 169.747C406.462 132.914 364.448 133.512 338.309 104.583C312.234 75.7245 315.03 45.9308 282.716 23.1272C212.768 -26.2346 127.459 10.751 62.2451 65.3961C29.1087 93.1621 5.57365e-05 129.239 0 154.337Z",
			fill: "#FFF2F5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 219,
			cy: 72,
			r: 47,
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 78,
			cy: 76,
			rx: 78,
			ry: 76,
			transform: "matrix(-1 0 0 1 194 98)",
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 325.5,
			cy: 185,
			rx: 31.5,
			ry: 32,
			stroke: "#F2A2B5",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 126.311,
			y: 58.1877,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 126.311 58.1877)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 303.897,
			y: 107.875,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 303.897 107.875)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 103.252,
			y: 218.341,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 103.252 218.341)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 372.907,
			y: 215.531,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 372.907 215.531)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 128.205,
			y: 47.8472,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 128.205 47.8472)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 305.792,
			y: 97.5344,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 305.792 97.5344)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 105.146,
			y: 208,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 105.146 208)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 374.802,
			y: 205.19,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 374.802 205.19)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.2705 68.0039C88.7341 68.1677 93.9238 73.4588 93.9238 79.9619L93.9199 80.2705C93.7561 86.734 88.4649 91.9237 81.9619 91.9238L81.6533 91.9199C75.2924 91.7587 70.1651 86.6315 70.0039 80.2705L70 79.9619C70 73.3557 75.3558 68.0002 81.9619 68L82.2705 68.0039ZM77.6953 86.6816C78.9289 87.4666 80.3916 87.9238 81.9619 87.9238C86.3589 87.9237 89.9237 84.3589 89.9238 79.9619C89.9238 78.3917 89.4674 76.9288 88.6826 75.6953L77.6953 86.6816ZM81.9619 72C77.5649 72.0002 74 75.5649 74 79.9619C74.0001 81.6082 74.5004 83.1377 75.3564 84.4072L86.4082 73.3555C85.1386 72.4994 83.6083 72 81.9619 72Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M231.271 229.004C237.734 229.168 242.924 234.459 242.924 240.962L242.92 241.271C242.756 247.734 237.465 252.924 230.962 252.924L230.653 252.92C224.293 252.759 219.165 247.631 219.004 241.271L219 240.962C219 234.356 224.356 229 230.962 229L231.271 229.004ZM226.695 247.682C227.929 248.467 229.392 248.924 230.962 248.924C235.359 248.924 238.924 245.359 238.924 240.962C238.924 239.391 238.468 237.928 237.683 236.694L226.695 247.682ZM230.962 233C226.565 233 223 236.565 223 240.962C223 242.608 223.5 244.138 224.356 245.407L235.408 234.355C234.139 233.499 232.608 233 230.962 233Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.344 59.2631C274.171 58.627 274.65 58 275.309 58H284.691C285.35 58 285.829 58.627 285.656 59.2631L280.965 76.4625C280.697 77.445 279.303 77.445 279.035 76.4625L274.344 59.2631Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 280,
			cy: 83,
			r: 3,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_5649_527)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M74.2964 154.795C74.2964 154.795 80.9003 164.394 91.0955 164.394C101.291 164.394 107.895 154.795 107.895 154.795C107.895 154.795 136.693 185.993 139.093 189.593C141.493 193.193 119.529 188.393 97.0949 188.393C74.6608 188.393 53.8974 194.393 58.6971 184.793C63.4968 175.194 74.2964 154.795 74.2964 154.795Z",
				fill: "#FFC9D6"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.3995 170.394C66.3995 170.394 54.9032 185.993 75.999 182.393C97.0949 178.794 134.796 182.393 134.796 182.393C134.796 182.393 136.693 185.993 139.093 189.593C141.493 193.193 119.529 188.393 97.0949 188.393C74.6608 188.393 53.8974 194.393 58.6971 184.793C63.4968 175.194 66.3995 170.394 66.3995 170.394Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_5649_527)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M91.2252 116.5C104.217 116.5 114.749 127.033 114.749 140.024C114.748 153.016 104.217 163.548 91.2252 163.548C78.2334 163.548 67.701 153.016 67.7008 140.024C67.7008 127.032 78.2333 116.5 91.2252 116.5Z",
				fill: "#FFCAD7",
				stroke: "#FF92AC",
				strokeWidth: 5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.199 128.4C101.135 129.518 102.749 131.126 103.897 133.081C105.045 135.036 105.692 137.279 105.78 139.61C105.869 141.94 105.396 144.288 104.404 146.444C103.413 148.6 101.932 150.498 100.095 151.97C98.2567 153.442 96.1181 154.443 93.8682 154.883C91.6183 155.323 89.3265 155.19 87.1959 154.495C85.0652 153.8 83.1614 152.564 81.6532 150.897C80.145 149.231 79.0788 147.184 78.5492 144.94C78.9685 146.717 81.1509 148.379 82.3451 149.699C83.8168 150.549 85.5214 151.262 87.2083 151.812C88.8953 152.363 91.6935 152.321 93.4749 151.972C95.2562 151.623 96.9494 150.831 98.4045 149.666C99.8596 148.5 101.243 146.925 102.028 145.218C102.813 143.511 103.401 140.315 103.33 138.47C103.26 136.624 103.257 134.313 102.348 132.765C101.439 131.217 100.732 129.285 99.199 128.4Z",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 91.2331,
			cy: 130.269,
			rx: 5.47592,
			ry: 3.7765,
			transform: "rotate(-2.6891 91.2331 130.269)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 82.9495,
			cy: 132.667,
			rx: 1.45108,
			ry: 1.45108,
			transform: "rotate(-2.6891 82.9495 132.667)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_ddddd_5649_527)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 126.048,
				y: 125.885,
				width: 115.366,
				height: 72.8627,
				rx: 8,
				transform: "rotate(5.81663 126.048 125.885)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.519 131.082C125.811 128.212 128.375 126.122 131.246 126.414L235.623 137.047C238.494 137.34 240.583 139.904 240.291 142.774L239.128 154.189L124.356 142.497L125.519 131.082Z",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 181.81,
			y1: 181.983,
			x2: 223.217,
			y2: 186.201,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 182.99,
			y1: 170.405,
			x2: 224.397,
			y2: 174.623,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 184.169,
			y1: 158.827,
			x2: 225.576,
			y2: 163.045,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 180.631,
			y1: 193.561,
			x2: 214.487,
			y2: 197.01,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 133.159,
			y1: 135.321,
			x2: 162.485,
			y2: 138.308,
			stroke: "white",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 130.48,
			y: 151.194,
			width: 40.9853,
			height: 40.9853,
			rx: 3,
			transform: "rotate(5.81663 130.48 151.194)",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.652 185.501C152.655 183.491 151.463 182.016 151.755 179.148C151.93 177.426 153.406 176.45 154.021 175.022C154.636 173.594 155.082 171.875 155.435 170.627C155.788 169.379 155.927 168.897 156.186 167.555C156.506 165.881 155.871 161.41 150.099 160.822C144.328 160.234 142.801 164.485 142.78 166.19C142.764 167.556 142.803 168.056 142.896 169.35C142.99 170.643 143.078 172.416 143.392 173.939C143.706 175.461 144.956 176.716 144.781 178.437C144.489 181.305 143.023 182.509 138.703 183.673C134.368 184.838 131.499 186.131 131.386 187.239L130.858 192.43L162.571 195.66L163.1 190.469C163.212 189.363 160.661 187.518 156.652 185.501Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_dddd_5649_527)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 157.578,
				y: 216.506,
				width: 156.208,
				height: 31.0384,
				transform: "rotate(-45 157.578 216.506)",
				fill: "#EF476F"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 178.31,
				y: 103.291,
				width: 161.543,
				height: 33.2244,
				transform: "rotate(45 178.31 103.291)",
				fill: "#EF476F"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_5649_527",
				x: 52,
				y: 154.795,
				width: 93.2732,
				height: 54.1369,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 12 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 0.791667 0 0 0 0 0.84127 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5649_527",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_5649_527",
				x: 64.0008,
				y: 114,
				width: 54.4481,
				height: 54.4481,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .599999 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.5 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5649_527",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_ddddd_5649_527",
				x: 100.433,
				y: 124.654,
				width: 144.618,
				height: 127.641,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1,
						dy: 5
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_527",
						result: "effect2_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -3,
						dy: 12
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_527",
						result: "effect3_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -6,
						dy: 21
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_527",
						result: "effect4_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9,
						dy: 33
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5649_527",
						result: "effect5_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5649_527",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dddd_5649_527",
				x: 144.817,
				y: 101.291,
				width: 157.721,
				height: 175.721,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.18 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_527",
						result: "effect2_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_527",
						result: "effect3_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 26 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_527",
						result: "effect4_dropShadow_5649_527"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_5649_527",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAuthentificationNotAvailable);
export { ForwardRef as ReactComponent };
